import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ConditionRegistryAssociateAssociation extends ConditionRegistryCategory {
    label = 'Association';
    constructor(parent) {
        super(parent);
        super.init();
    }
    association_isCurrentAssociation = () => new ConditionRegistryItem({
        parent: this,
        label: 'Is current association',
        eval: ({ association, question }) => {
            if (!(question instanceof runtime.solidPackages.Rare.classes.QuestionAssociate))
                return false;
            return question.currentAssociation === association;
        }
    });
    association_isDraggingOverOptionTarget = () => new ConditionRegistryItem({
        parent: this,
        label: 'Ist Associate gerade in Zuodnung via Dragging',
        eval: ({ association }) => {
            if (!association)
                return false;
            if (!association.inner.aspectDraggable.isDragging)
                return false;
            if (association.actorIntersect.intersectingActorsOfType('option').length > 0)
                return true;
            return false;
        }
    });
    association_isComplete = () => new ConditionRegistryItem({
        parent: this,
        label: 'Is Complete',
        eval: ({ association }) => {
            if (!association)
                return false;
            return association.isAssociationComplete;
        }
    });
    association_isFinished = () => new ConditionRegistryItem({
        parent: this,
        label: 'Is Finished',
        eval: ({ association }) => {
            if (!association)
                return false;
            return association.isAssociationFinished;
        }
    });
    association_isCorrectlyAssociated = () => new ConditionRegistryItem({
        parent: this,
        label: 'isCorrectlyAssociated',
        eval: ({ association }) => {
            if (!association)
                return false;
            return association.isCorrectlyAssociated;
        }
    });
    association_isWronglyAssociated = () => new ConditionRegistryItem({
        parent: this,
        label: 'isWronglyAssociated',
        eval: ({ association }) => {
            if (!association)
                return false;
            return association.isWronglyAssociated;
        }
    });
    association_shouldShowTemporaryFalseFeedback = () => new ConditionRegistryItem({
        parent: this,
        label: 'shouldShowTemporaryFalseFeedback_1500ms',
        eval: ({ association }) => {
            if (!association)
                return false;
            return association.associationUI.shouldShowTemporaryFalseFeedback_1500ms;
        }
    });
}
